<script>
    import {createEventDispatcher, onMount} from 'svelte';

    export let device = {}, checked = false;
    
    let value = device.id;
    let select = checked;
    
    const dispatcher = createEventDispatcher();

    const changeSelection = () => {
        select = !select;
        dispatcher("update_selection", {id: value, select});
    }

</script>

    <label>
        <input type="checkbox" {value} checked={checked} on:change={e => changeSelection(e)}/>
        {`${device.name} (${device.type})`}

    </label>


<style>
    label{
        display: flex;
        height: 50px;
        width: var(--display-single_select_width);
        justify-content: space-between;
        align-items: center;
    }

    span{
        color: green;
    }

</style>